(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heritage-page-full-bleed"] && !Shopify.designMode) return;
  try {
    (function () {
    function initHrgCarousels() {
      document.querySelectorAll('[data-hrg-carousel]').forEach(function (root) {
        var track = root.querySelector('[data-hrg-carousel-track]');
        var prev = root.querySelector('[data-hrg-carousel-prev]');
        var next = root.querySelector('[data-hrg-carousel-next]');
        if (!track) return;
        var delta = 320;
        function scrollByAmount(amount) {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function () {
          scrollByAmount(-delta);
        });
        if (next) next.addEventListener('click', function () {
          scrollByAmount(delta);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHrgCarousels);
    } else {
      initHrgCarousels();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maison-najju-full-bleed"] && !Shopify.designMode) return;
  try {
    (function () {
    function initNmn2Carousels() {
      document.querySelectorAll('[data-nmn2-carousel]').forEach(function (root) {
        var track = root.querySelector('[data-nmn2-carousel-track]');
        var prev = root.querySelector('[data-nmn2-carousel-prev]');
        var next = root.querySelector('[data-nmn2-carousel-next]');
        if (!track) return;
        var delta = 320;
        function scrollByAmount(amount) {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function () {
          scrollByAmount(-delta);
        });
        if (next) next.addEventListener('click', function () {
          scrollByAmount(delta);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNmn2Carousels);
    } else {
      initNmn2Carousels();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["najju-planet-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('najju-planet-experience')) {
    const offered = new Set();
    const events = new Set(['planet_offer_view','planet_opt_in','planet_opt_out','planet_story_open','planet_video_play','planet_learn_more']);
    const publish = (name, currency) => {
      if (!events.has(name)) return;
      const shopify = window.Shopify;
      if (shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      if (typeof shopify?.analytics?.publish !== 'function') return;
      try { Promise.resolve(shopify.analytics.publish(name,{surface:'cart',currency_code:currency})).catch(() => {}); } catch {}
    };
    class NajjuPlanetExperience extends HTMLElement {
      static get observedAttributes() { return ['data-cart-selected','data-currency']; }
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.copy = JSON.parse(this.querySelector('[data-planet-copy]').textContent);
        this.dialog = this.querySelector('dialog');
        this.status = this.querySelector('[data-planet-status]');
        this.native = this.querySelector('.np-native');
        this.observer = new MutationObserver(() => this.prepare());
        this.observer.observe(this.native,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});
        this.addEventListener('change',event => { if (event.target === this.input) this.confirmChange(); },{signal});
        this.querySelector('[data-story-open]').addEventListener('click',() => this.openStory(),{signal});
        this.storyButtons = [...this.querySelectorAll('[data-trace-contribute]')];
        this.storyButtons.forEach(button => button.addEventListener('click',() => {
          if (this.pending || !this.input || this.input.disabled || this.dataset.enhanced !== 'true') return;
          this.input.click();
        },{signal}));
        this.querySelector('[data-story-close]').addEventListener('click',() => this.dialog.close(),{signal});
        const updateStoryChrome = () => { this.dialog.dataset.scrolled = String(this.dialog.scrollTop > this.dialog.clientHeight); };
        this.dialog.addEventListener('scroll',updateStoryChrome,{passive:true,signal});
        this.dialog.addEventListener('click',event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        },{signal});
        this.dialog.addEventListener('close',() => {
          this.querySelector('video')?.pause();
          document.documentElement.style.overflow = this.previousOverflow ?? '';
          this.querySelector('[data-story-open]').focus({preventScroll:true});
        },{signal});
        this.querySelector('[data-learn-more]').addEventListener('click',() => publish('planet_learn_more',this.dataset.currency),{signal});
        document.addEventListener('cart:update',event => {
          if (event.detail?.data?.source === 'najju-planet' || this.pending) return;
          const cart = event.detail?.resource;
          if (Array.isArray(cart?.items) && Number.isInteger(cart?.item_count)) this.syncCart(cart);
          else this.readCart().then(cart => this.syncCart(cart)).catch(() => {});
        },{signal});
        document.addEventListener('visitorConsentCollected',() => this.reportOffer(),{signal});
        this.visibility = new IntersectionObserver(entries => { this.inView = entries.some(entry => entry.isIntersecting); this.reportOffer(); },{threshold:.4});
        this.visibility.observe(this);
        this.prepare();
        this.refreshStory();
      }
      disconnectedCallback() {
        this.abort?.abort(); this.abort = null;
        this.observer?.disconnect(); this.visibility?.disconnect();
        if (this.dialog?.open) { this.querySelector('video')?.pause(); document.documentElement.style.overflow = this.previousOverflow ?? ''; }
        this.lockCheckout(false);
      }
      attributeChangedCallback() { if (this.abort) queueMicrotask(() => this.prepare()); }
      setText(node,text) { if (node && node.textContent !== text) node.textContent = text; }
      prepare() {
        const banner = this.native?.querySelector('.shopify-planet-banner-v2-container.buyer-contribution');
        if (!banner || !banner.classList.contains('shopify-planet-banner-v2-initialized') || banner.classList.contains('shopify-planet-banner-v2-fetching-price') || banner.classList.contains('shopify-planet-banner-v2-product-missing')) return;
        const title = banner.querySelector('.shopify-planet-banner-v2-title')?.textContent.trim();
        const match = title?.match(/^Add (.+) for carbon removal$/);
        if (!match || match[1].includes('{cost}')) return;
        this.amount = match[1];
        this.input = banner.querySelector('input[type="checkbox"]');
        if (!this.input) return;
        this.input.id = this.id + '-choice';
        const label = this.input.closest('label');
        let caption = label.querySelector('.np-control-label');
        if (!caption) { caption = document.createElement('strong'); caption.className = 'np-control-label'; label.append(caption); }
        this.caption = caption;
        if (!this.pending) {
          const selected = this.dataset.cartSelected === 'true';
          this.input.checked = selected;
          window.shopifyPlanetContributionInCart = selected;
          this.dataset.selected = String(selected);
        }
        this.dataset.enhanced = 'true';
        this.refreshCopy();
        this.reportOffer();
      }
      refreshCopy() {
        const selected = this.dataset.selected === 'true';
        const label = selected ? this.copy.remove : this.copy.add.split('__AMOUNT__').join(this.amount);
        this.setText(this.caption,label);
        if (this.input.getAttribute('aria-label') !== label) this.input.setAttribute('aria-label',label);
        this.setText(this.querySelector('[data-offer-body]'),this.copy.body.split('__AMOUNT__').join(this.amount));
        this.refreshStory();
      }
      refreshStory() {
        const ready = !!this.input && !!this.amount && this.dataset.enhanced === 'true';
        const selected = this.dataset.selected === 'true';
        this.storyButtons?.forEach(button => {
          button.disabled = !ready || !!this.pending;
          button.setAttribute('aria-pressed',String(selected));
          if (ready) this.setText(button,(selected ? this.copy.storyRemove : this.copy.storyAdd).split('__AMOUNT__').join(this.amount));
        });
        this.querySelectorAll('[data-trace-status]').forEach(node => this.setText(node,this.status?.textContent || ''));
        const unavailable = this.querySelector('[data-trace-unavailable]');
        if (unavailable) unavailable.hidden = ready;
      }
      reportOffer() {
        const key = this.id + ':' + this.dataset.currency;
        if (!this.inView || this.dataset.enhanced !== 'true' || offered.has(key) || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
        offered.add(key); publish('planet_offer_view',this.dataset.currency);
      }
      async readCart() {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(2500)});
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }
      hasContribution(cart) {
        return cart.items.some(item => String(item.variant_id) === String(window.shopifyPlanetContributionVariant) && item.quantity > 0);
      }
      syncCart(cart) {
        if (!this.isConnected || !this.input || this.pending) return;
        const selected = this.hasContribution(cart);
        this.dataset.cartSelected = String(selected);
        this.dataset.selected = String(selected);
        this.dataset.currency = cart.currency;
        this.input.checked = selected;
        window.shopifyPlanetContributionInCart = selected;
        this.refreshCopy();
      }
      lockCheckout(lock) {
        if (lock) {
          this.locked = [...document.querySelectorAll('.cart__ctas, .additional-checkout-buttons')].filter(node => !node.inert);
          this.locked.forEach(node => node.inert = true);
        } else { this.locked?.forEach(node => node.inert = false); this.locked = []; }
      }
      async confirmChange() {
        if (this.pending) return;
        const desired = this.input.checked;
        this.pending = true;
        this.input.disabled = true;
        this.setAttribute('aria-busy','true');
        this.setText(this.status,this.copy.pending);
        this.refreshStory();
        this.lockCheckout(true);
        let confirmed = null;
        let latest = null;
        try {
          const deadline = Date.now() + 9000;
          while (Date.now() < deadline && this.isConnected) {
            await new Promise(resolve => setTimeout(resolve,350));
            try { latest = await this.readCart(); } catch { continue; }
            if (this.hasContribution(latest) === desired) { confirmed = latest; break; }
          }
          if (!confirmed) throw new Error('Planet change not confirmed');
          this.pending = false;
          this.syncCart(confirmed);
          publish(desired ? 'planet_opt_in' : 'planet_opt_out',confirmed.currency);
          this.setText(this.status,'');
          const { CartUpdateEvent } = await import('@theme/events');
          document.dispatchEvent(new CartUpdateEvent(confirmed,this.id,{source:'najju-planet',itemCount:confirmed.item_count}));
        } catch {
          this.pending = false;
          if (latest) this.syncCart(latest);
          else this.prepare();
          this.setText(this.status,this.copy.error);
        } finally {
          this.pending = false;
          if (this.input) this.input.disabled = false;
          this.removeAttribute('aria-busy');
          this.lockCheckout(false);
          this.refreshStory();
        }
      }
      openStory() {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal(); document.documentElement.style.overflow = 'hidden';
        publish('planet_story_open',this.dataset.currency);
        this.refreshStory();
      }

    }
    customElements.define('najju-planet-experience',NajjuPlanetExperience);
  }
  } catch(e) { console.error(e); }
})();

})();
